import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Stylefinder.css";
import style_data1 from "./StyleData1";
import style_data2 from "./StyleData2";
import style_data3 from "./StyleData3";
import style_data4 from "./StyleData4";




// import required modules
import {Pagination, Navigation } from "swiper";

function Stylefocus() {
    const [stdata1] = useState(style_data1);
    const [stdata2] = useState(style_data2);
    const [stdata3] = useState(style_data3);
    const [stdata4] = useState(style_data4);

    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper4"
            >
                <SwiperSlide>
                    <Stylebox1 stdata1={stdata1} />
                </SwiperSlide>
                <SwiperSlide>
                    <Stylebox2 stdata2={stdata2} />
                </SwiperSlide>
                <SwiperSlide>
                    <Stylebox3 stdata3={stdata3} />
                </SwiperSlide>
                <SwiperSlide>
                    <Stylebox4 stdata4={stdata4} />
                </SwiperSlide>
            </Swiper>
        </>
    );
}



function Stylebox1(props) {
    return (
        <>
            {
                props.stdata1.map((a, i) => {
                    return (
                        <div className="stBox">
                            <img src={a.imgurl} />
                            <span>{a.text}</span>
                        </div>
                    )
                })
            }
        </>
    )
}

function Stylebox2(props) {
    return (
        <>
            {
                props.stdata2.map((a, i) => {
                    return (
                        <div className="stBox">
                            <img src={a.imgurl} />
                            <span>{a.text}</span>
                        </div>
                    )
                })
            }
        </>
    )
}

function Stylebox3(props) {
    return (
        <>
            {
                props.stdata3.map((a, i) => {
                    return (
                        <div className="stBox">
                            <img src={a.imgurl} />
                            <span>{a.text}</span>
                        </div>
                    )
                })
            }
        </>
    )
}

function Stylebox4(props) {
    return (
        <>
            {
                props.stdata4.map((a, i) => {
                    return (
                        <div className="stBox">
                            <img src={a.imgurl} />
                            <span>{a.text}</span>
                        </div>
                    )
                })
            }
        </>
    )
}




export default Stylefocus;
